export default __webpack_public_path__ + "static/media/engineering_white_24dp.2a5cb9b2.svg";